import type { IUser } from 'store/declare';

import type { VOXUser } from 'providers/declare';
import { EVoxRoles } from 'providers/declare';

import { API } from 'constants/api';

import { getUserTypeByRole } from './getUserTypeByRole';

/** Получение информации о пользователе из данных с VOX формата */
export function userAdapter(user: VOXUser): IUser {
    const { _id, data, role = EVoxRoles.UNKNOWN, userId } = user;

    const { name, photo, position } = data;

    return {
        avatar: photo ? `${API.STATIC_API}/images/${photo.path}${photo.file_name}` : undefined,
        id: _id,
        isMuted: false,
        name,
        position,
        role,
        type: getUserTypeByRole(role),
        voxId: `${userId}`,
    };
}
